import { DiscountType } from '../discount';
import { discountTypeFromApi, discountTypeToApi } from '../discount/discount_type';
import { Bundle as APIBundle, BundleItem as APIBundleItem } from '@vendasta/billing';

export const isBundle = (b: Bundle | undefined): b is Bundle => {
  return !!b;
};
export interface Bundle {
  merchantId: string;
  bundleId: string;
  name: string;
  hideBundleDetails: boolean;
  items: BundleItem[];
  created: Date;
  updated: Date;
}

export interface BundleItem {
  productId: string;
  discountType: DiscountType;
  discountAmount: number;
  quantity: number;
  defaultSku: string;
  price: Price;
}

export interface Price {
  amount: number;
  setupFee: number;
}

export function bundleFromApi(apiBundle: APIBundle): Bundle | undefined {
  if (!apiBundle) {
    return undefined;
  }
  const items = (apiBundle.items || []).map((item) => bundleItemFromApi(item));
  return {
    merchantId: apiBundle.merchantId,
    bundleId: apiBundle.bundleId,
    name: apiBundle.name,
    hideBundleDetails: apiBundle.hideBundleDetails,
    items: items,
    created: apiBundle.created,
    updated: apiBundle.updated,
  } as Bundle;
}

export function bundleItemFromApi(apiBundleItem: APIBundleItem): BundleItem {
  return {
    productId: apiBundleItem.productId,
    discountType: discountTypeFromApi(apiBundleItem.discountType),
    discountAmount: apiBundleItem.discountAmount,
    quantity: apiBundleItem.quantity,
    defaultSku: apiBundleItem.defaultSku,
    price: apiBundleItem.price,
  } as BundleItem;
}

export function bundleItemToApi(bundleItem: BundleItem): APIBundleItem {
  return {
    productId: bundleItem.productId,
    discountType: discountTypeToApi(bundleItem.discountType),
    discountAmount: bundleItem.discountAmount,
    quantity: bundleItem.quantity,
    defaultSku: bundleItem.defaultSku,
    price: bundleItem.price,
  } as APIBundleItem;
}
